﻿import global from './js/globals';
import creator from './js/elementCreator';

"use strict";
var privateFns, clickFns, intranett;
var urlBase = {partList: {}, addPart: {}};
privateFns = {
	sharePage: function(){
		var el = creator.createDiv({id: "share-page", css: "drop_downs"});
		el.setAttribute("data-enhance", "false");
		var userMessage1 = creator.createDiv({css: "user-message-intranett", text: "OBS: Intranettversjonen fungerer bare internt i kommunen"});
		el.appendChild(userMessage1);
		let shareControls = creator.createDiv({id: "share-controls", css: "drop_downs"});
		let pointCheckBox = creator.createInput({type: "checkbox", id: "pointNoMark", group: "point", name: "Punkt"});
		pointCheckBox.checked = true;
		shareControls.appendChild(pointCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointNoMark", text: "Punkt"}));
		shareControls.appendChild(creator.createBr({}));
		let pointMarkCheckBox = creator.createInput({type: "checkbox", id: "pointMark", group: "point", name: "Punkt markert"});
		shareControls.appendChild(pointMarkCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointMark", text: "Punkt markert"}));
		shareControls.appendChild(creator.createBr({}));
		let minCheckBox = creator.createInput({type: "checkbox", id: "min", group: "min", name: "Min"});
		shareControls.appendChild(minCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "min", text: "Minimer"}));
		shareControls.appendChild(creator.createBr({}));
		let modeCheckBox = creator.createInput({type: "checkbox", id: "mode", group: "mode", name: "Mode"});
		minCheckBox.checked = true; 
		
		el.appendChild(shareControls);
		el.appendChild(creator.createDiv({id: "shareUrl", css: "share-url"}));
		var userMessage2 = creator.createDiv({css: "user-message-intranett", text: "Lenken over åpner i et nytt vindu. Der kan du lagre bokmerke eller snarveg til det du ser på skjermen nå."});
		el.appendChild(userMessage2);
		var span = creator.createSpan({text: "Del via: "});
		el.appendChild(span);
		
		pointCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.point = "&north=" + global.map.getView().getCenter()[1]  + "&east=" + global.map.getView().getCenter()[0]; 
			urlBase.addPart.point = e.target.checked;
			if(e.target.checked){
				urlBase.addPart.pointMark = !e.target.checked;
				pointMarkCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		pointMarkCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.pointMark = "&lat=" + global.map.getView().getCenter()[1]  + "&lon=" + global.map.getView().getCenter()[0]; 
			urlBase.addPart.pointMark = e.target.checked;
			if(e.target.checked){					
				urlBase.addPart.point = !e.target.checked;
				pointCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		minCheckBox.onclick = function(e){
			urlBase.partList.min = "&min=true"; 
			urlBase.addPart.min = e.target.checked;
			privateFns.updateUrl();
		};
		modeCheckBox.onclick = function(e){
			urlBase.addPart.mode = e.target.checked;
			privateFns.updateUrl();
		};
		
		var container = creator.createDiv({css: "share-btn-ct"});
		container.appendChild(creator.createA({id: "share-email", title: "Del via epost", href: "mailto:?subject=planinnsyn.oslo.no&amp;body=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "icon-Epost"}), ariaLabel: "Del lenke til planinnsyn via epost"}));
		container.appendChild(creator.createA({id: "share-twitter", title: "Del via twitter", href: "http://twitter.com/share?url=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-twitter"}), ariaLabel: "Del lenke til planinnsyn via twitter"}));
		container.appendChild(creator.createA({id: "share-facebook", title: "Del via facebook", href: "http://facebook.com/sharer.php?u=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-facebook"}), ariaLabel: "Del lenke til planinnsyn via facebook"}));
		
		var copyButton = creator.createButton({id: "copy-link", text: "Kopier lenke"});
		copyButton.onclick = function(){
			var doc = document, text = doc.getElementsByClassName("permalink")[0];
			var range, select = true;
			if (doc.body.createTextRange) {
				range = doc.body.createTextRange();
				range.moveToElementText(text);
				range.select();
			} else if (window.getSelection) {
				var selection = window.getSelection();
				range = doc.createRange();
				range.selectNodeContents(text);
				selection.removeAllRanges();
				selection.addRange(range);
			} else {
				console.log("tekst selektering støttes ikke");
				select = false;
			}
			if (select) {
				if (doc.execCommand("copy")) {
					alert("Lenken er kopiert");
				} else {
					alert("Nettleseren din støtter ikke automatisk kopiering. Kopier lenken manuelt.");
				}
			}
		};
		container.appendChild(copyButton);
		el.appendChild(container);
		var closeButton = creator.createButton({css: "close-me hide-me", ariaLabel: "Lukk delemeny", text: "Lukk"});
		closeButton.onclick = function(){
			$("#share-page").hide(250);
		};
		el.appendChild(closeButton);
		return el;
	},
	helpMenu: function() {
		var el = creator.createDiv({id: "help-page", css: "drop-downs floating-win"});
		el.setAttribute("data-enhance", "false");
		
		var header = creator.createHeader({});
		var btn = creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul tips"});
		btn.appendChild(creator.createIcon({css: "icon-Close"}));
		btn.onclick = function(){
			$("#help-page").hide();
			$("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
			$("#planinnsyn-hjelp").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
		};
		header.appendChild(btn);
		el.appendChild(header);
		
		var content = creator.createDiv({css: "content"});
		
		var article = creator.createDiv({});
		var articleArticle = creator.createArticle({});
		articleArticle.appendChild(creator.createParagraph({text: "Plan- og bygningsetaten ønsker å levere data av høy kvalitet, men kan ikke garantere at innholdet i tjenesten er uten feil og mangler."}));
		articleArticle.appendChild(creator.createParagraph({text: "Kart og eiendomsinformasjon er beskyttet etter åndsverkloven."}));
		article.appendChild(articleArticle);
		content.appendChild(article);
		
		//<!-- Hvordan bruke kartet -->
		var bruk = creator.createDiv({id: "help-topic-bruk", css: "help-topic"});
		var brukButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan bruke kartet", text: "Hvordan forstå kartet"});
		brukButton.onclick = function () {
			if($("#brukArticle").is(":visible")) {
				$("#brukArticle").hide(250);
				$("#help-topic-bruk").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#brukArticle").show(200);
				$("#help-topic-bruk").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		brukButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		bruk.appendChild(brukButton);
		var brukArticle = creator.createArticle({id: "brukArticle"});
		brukArticle.appendChild(creator.createH4({text: "Hvordan forstå kartet"}));
		brukArticle.appendChild(creator.createParagraph({text: "Kartet viser solinnstråling beregnet ut fra en digital overflatemodell som inkluderer skygge fra terreng, vegetasjon, bygg og andre faste installasjoner."}));
		brukArticle.appendChild(creator.createParagraph({text: "Fargene viser hvor mye solenergi overflaten utsettes for i løpet av et år (kWh/m²)."}));
		brukArticle.appendChild(creator.createParagraph({text: "Du kan laste ned data for hver uke ved å trykke på en takflate."}));
		bruk.appendChild(brukArticle);
		
		content.appendChild(bruk);
		
		//<!-- Datagrunnlag -->
		var grunnlag = creator.createDiv({id: "help-topic-grunnlag", css: "help-topic"});
		var grunnlagButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan bruke kartet", text: "Datagrunnlag"});
		grunnlagButton.onclick = function () {
			if($("#grunnlagArticle").is(":visible")) {
				$("#grunnlagArticle").hide(250);
				$("#help-topic-grunnlag").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#grunnlagArticle").show(200);
				$("#help-topic-grunnlag").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		grunnlagButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		grunnlag.appendChild(grunnlagButton);
		var grunnlagArticle = creator.createArticle({id: "grunnlagArticle"});
		grunnlagArticle.appendChild(creator.createUl({listItems: [
			"Digital overflatemodell generert fra laserskanning gjennomført i 2021. Overflatemodellen inkluderer det som skaper skygger, som terreng, bygninger, vegetasjon og andre permanente installasjoner.",
			"Takflater fra Oslo kommunes grunnkart",
			"Solinnstrålingsdata fra Meteorologisk institutts målestasjon på Blindern som har registreringer fra 2014 og frem til i dag. Det er beregnet en gjennomsnittlig solinnstrålingsverdi for hver uke."
		]}));
		grunnlag.appendChild(grunnlagArticle);
		
		content.appendChild(grunnlag);
		
		//<!-- Prosess -->
		var prosess = creator.createDiv({id: "help-topic-prosess", css: "help-topic"});
		var prosessButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan bruke kartet", text: "Hvordan lagde vi kartet"});
		prosessButton.onclick = function () {
			if($("#prosessArticle").is(":visible")) {
				$("#prosessArticle").hide(250);
				$("#help-topic-prosess").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#prosessArticle").show(200);
				$("#help-topic-prosess").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		prosessButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		prosess.appendChild(prosessButton);
		var prosessArticle = creator.createArticle({id: "prosessArticle"});
		prosessArticle.appendChild(creator.createParagraph({text: 'Kartet viser solinnstråling beregnet ut fra en digital overflatemodell som inkluderer skygge fra terreng, vegetasjon, bygg og andre faste installasjoner.Solinnstrålingen er beregnet med verktøyet "Area solar radiation" i ArcGIS Pro. Det er gjort beregninger for hver uke med 2 ulike kombinasjoner av andel direkte og indirekte stråling. "Vintergrafen" har større andel indirekte stråling og passer veldig bra vinter, vår og høst, men overestimerer om sommeren. "Sommergrafen" med en lavere andel indirekte innstråling passer bedre om sommeren, men underestimerer vinter, vår og høst. I kalibreringen kombinerer vi resultater med "sommerverdier" og "vinterverdier" slik at vi kommer så nærme gjennomsnittsmålingene fra Blindern som mulig.'}));
		let kalibreringImg = creator.createImage({src: "./kalibrering.png"});
		kalibreringImg.style.width = "100%";
		prosessArticle.appendChild(kalibreringImg);
		prosessArticle.appendChild(creator.createParagraph({text: "Kartet viser hvor mye energi som samles over et år i wattimer per kvadratmeter (Wh/m²). Tak er inndelt i takflater og i nedlastingstabellen vises hvor mye energi som samles hver uke per kvadratmeter (Wh/m²)"}));
		prosess.appendChild(prosessArticle);
		
		content.appendChild(prosess);

		//<!-- Hensyn -->
		var hensyn = creator.createDiv({id: "help-topic-hensyn", css: "help-topic"});
		var hensynButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan bruke kartet", text: "Du må også tenke på dette"});
		hensynButton.onclick = function () {
			if($("#hensynArticle").is(":visible")) {
				$("#hensynArticle").hide(250);
				$("#help-topic-hensyn").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#hensynArticle").show(200);
				$("#help-topic-hensyn").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		hensynButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		hensyn.appendChild(hensynButton);
		var hensynArticle = creator.createArticle({id: "hensynArticle"});
		hensynArticle.appendChild(creator.createUl({listItems: [
			"Installasjoner på taket kan påvirke hvor egnet taket er for installasjon av solenergianlegg (for eksempel ventilasjonsanlegg, piper eller takvinduer)",
			"Flate tak kan produsere mer energi enn solkartet antyder fordi solenergianlegg kan installeres med valgfri og optimalisert vinkel. Store flate tak er ofte godt egnet fordi installasjon kan gjøres uten sikringsutstyr dersom man holder avstand til kantene.",
			"<a href='https://www.oslo.kommune.no/plan-bygg-og-eiendom/skal-du-bygge-rive-eller-endre/ma-du-sende-byggesoknad/solcelle-eller-solfangeranlegg/' target='_blank'>Installasjon av solenergianlegg kan være søknadspliktig.<a/>",
			"Du bør også undersøke om det finnes planer for eiendommene rundt som kan påvirke den fremtidige solinnstrålingen.",
		]}));
		hensyn.appendChild(hensynArticle);
		
		content.appendChild(hensyn);
		
		//<!-- Støtte -->
		var stotte = creator.createDiv({id: "help-topic-stotte", css: "help-topic"});
		var stotteButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan bruke kartet", text: "Støtte til solanlegg"});
		stotteButton.onclick = function () {
			if($("#stotteArticle").is(":visible")) {
				$("#stotteArticle").hide(250);
				$("#help-topic-stotte").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#stotteArticle").show(200);
				$("#help-topic-stotte").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		stotteButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		stotte.appendChild(stotteButton);
		var stotteArticle = creator.createArticle({id: "stotteArticle"});
		stotteArticle.appendChild(creator.createParagraph({text: 'Du kan søke om støtte til å etablere solenergianlegg.'}));
		stotteArticle.appendChild(creator.createH3({text: 'Det finnes flere støtteordninger'}));
		stotteArticle.appendChild(creator.createUl({listItems: [
			"<a href= 'https://www.oslo.kommune.no/tilskudd-legater-og-stipend/tilskudd-til-installasjon-av-solceller-i-borettslag-sameier-og-yrkesbygg/#gref' target='_blank'>Klima- og energifondet<i class='icon-new-window'></i></a>",
			"<a href= 'https://www.enova.no/privat/alle-energitiltak/solenergi/el-produksjon-/' target='_blank'>Enova<i class='icon-new-window'></i></a>",
		]}));
		stotte.appendChild(stotteArticle);
		content.appendChild(stotte);
		
		//<!-- Søk -->
		var sok = creator.createDiv({id: "help-topic-sok", css: "help-topic"});
		var sokButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan du søker", text: "Søk"});
		sokButton.onclick = function () {
			if($("#sokArticle").is(":visible")) {
				$("#sokArticle").hide(250);
				$("#help-topic-sok").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#sokArticle").show(200);
				$("#help-topic-sok").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		sokButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		sok.appendChild(sokButton);
		var sokArticle = creator.createArticle({id: "sokArticle"});
		sokArticle.appendChild(creator.createH4({text: "Hvordan søke?"}));
		sokArticle.appendChild(creator.createParagraph({text: "I søkefeltet kan du søke på adresser, stedsnavn, gårds- og bruksnummer, koordinat, plannavn eller saksnummer."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Adresse:</strong> For å søke på en adresse, start med å skrive inn gatenavn i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. Velg fra listen og du får opp et vindu med adresser for den valgte gaten."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Stedsnavn:</strong> For å søke på et stedsnavn, start med å skrive i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. På høyre side i listen ser du om forslaget er en gate eller et stedsnavn. Velg fra listen for å gå til stedet du ønsker."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Eiendom:</strong> For å søke på en eiendom, skriv på formen gnr/bnr.<br>Eksempel: <span>101/1</span>."}));
		sokArticle.appendChild(creator.createParagraph({text: '<strong>Koordinat:</strong> For å søke på koordinat skriv inn nord-koordinat og øst-koordinat adskilt med tegnet "|" (tasten til venstre for "1"). Søket fungerer også om du snur om på rekkefølgen på koordinatene.<br>Eksempel: <em>6643409|598546</em>'}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Plannavn:</strong> For å søke på en reguleringsplan skriver du inn plannavnet.<br>Eksempel: <span>S-3478</span>. Etter at du har skrevet inn minst tre tegn vil du få opp forslag på planer som passer med det du har skrevet inn. Velg plan fra listen."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Saksnummer:</strong> For å søke på en sak (byggesak/plansak) skriv inn saksnummeret i søkefeltet.<br>Eksempel: <em>201600477</em>."}));
		sok.appendChild(sokArticle);
		
		content.appendChild(sok);
		
		// <!-- Hvordan bruke verktøy -->
		var tools = creator.createDiv({id: "help-topic-tools", css: "help-topic"});
		var toolsButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan du bruker verktøy", id: "tool-info-btn", text: "Hvordan bruke verktøy"});
		toolsButton.onclick = function(){
			if($("#toolArticle").is(":visible")) {
				$("#toolArticle").hide(250);
				$("#help-topic-tools").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#toolArticle").show(200);
				$("#help-topic-tools").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		toolsButton.appendChild(creator.createIcon({css:"icon-Chevron-down tipsmenu-expander"}));
		tools.appendChild(toolsButton);
		var toolArticle = creator.createArticle({id: "toolArticle"});
		toolArticle.appendChild(creator.createH4({text: "Hvordan bruke verktøy?"}));
		var row  = creator.createDiv({css: "help-topic-tool-row"});
		var img  = creator.createDiv({css: "help-topic-tool-img", text: '<span class = "icon-Minus-sign"></span>'});
		var desc = creator.createDiv({css: "help-topic-tool-desc", text: "Zoom ut et nivå"});
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class = "icon-Plus-sign"></span>';
		desc.innerHTML = "Zoom inn et nivå";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = "<span>m²</span>";
		desc.innerHTML = "Mål areal. Klikk i kartet til det blå omrisset dekker arealet du ønsker å måle. Dobbeltklikk for å avslutte. Hold inne shift for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
				
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class= "icon-measure"></span>';
		desc.innerHTML = "Mål avstand. Klikk i punktet du ønsker å måle fra, klikk deretter for å legge inn knekkpunkter eller dobbeltklikk for å avslutte måling. Hold inne 'shift' for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class= "fa fa-pencil"></span>';
		desc.innerHTML = "Tegn i kartet. Klikk i kartet for å starte tegning. Klikk et annet sted i kartet for å lage en linje. Dobbelklikk for å avslutte tegning. Hold inne shift for å tegne frihånd. Bruk redigeringsknappen for å flytte linjer.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
				
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		img.innerHTML = "";
		
		img.innerHTML = '<span class= "glyphicon glyphicon-globe"></span>';
		desc.innerHTML = "Zoomer til hele kartet";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		img.innerHTML = "";
		
		img.innerHTML = '<span class= "glyphicon glyphicon-erase"></span>';
		desc.innerHTML = "Fjern tegninger, målinger og markering av eiendom og planer.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		for(var plug in global.registeredPlugins){
			var current = global.registeredPlugins[plug];
			if(current.userGuide){
				row = row.cloneNode(true);
				row.innerHTML = "";
				row.id = "tool-info-" + current.id;
				img = img.cloneNode(true);
				desc = desc.cloneNode(true);
				img.innerHTML = "";
				
				if(current.userGuide.img.type === "icon"){
					img.innerHTML = '<span class= "' + current.userGuide.img.className + '"></span>';
				}
				desc.innerHTML = current.userGuide.text;
				row.appendChild(img);
				row.appendChild(desc);
				row.className += current.userGuide.className ? " " +current.userGuide.className : "";
				toolArticle.appendChild(row);
			}
		}
		
		tools.appendChild(toolArticle);
		content.appendChild(tools);
		
		//<!-- Løsningen og kartdataene -->
		var about = creator.createDiv({id: "help-topic-about", css: "help-topic"});
		var aboutButton = creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om løsningen og kartdataene", text: "Løsningen og kartdataene"});
		aboutButton.onclick = function() {
			if($("#aboutArticle").is(":visible")) {
				$("#aboutArticle").hide(250);
				$("#help-topic-about").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#aboutArticle").show(200);
				$("#help-topic-about").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		aboutButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		about.appendChild(aboutButton);
		
		var aboutArticle = creator.createArticle({id: "aboutArticle"});
		aboutArticle.appendChild(creator.createH4({text: "Om løsningen"}));
		aboutArticle.appendChild(creator.createParagraph({text: "Løsningen utvikles og driftes av Plan- og bygningsetaten. Følgende rammeverk er benyttet for løsningen:"}));
		aboutArticle.appendChild(creator.createUl({listItems: ["JQuery-3.3.1", "OpenLayers-4.3.1", "Proj4JS", "RequireJS-2.1.16", "JQuery-Ui-1.12.0", "Jquery-Ui-datepicker-nb", "Jquery.mobile-1.4.5","Jquery.autocomplete-1.2.26","Font Awesome-4.6.1","popper-1.12.2","Bootstrap-4.3.1","Bootstrap.css-3.3.6"]}));
		aboutArticle.appendChild(creator.createParagraph({text: 'Ønsker du å gi tilbakemeldinger finner du en lenke nederst i denne menyen.'}));
		aboutArticle.appendChild(creator.createH4({text: "Om kartdataene"}));
		aboutArticle.appendChild(creator.createParagraph({text: '<span>Detaljer:</span>'}));
		aboutArticle.appendChild(creator.createParagraph({text: "<span>Flyfoto/Bakgrunnskart: </span>Flyfoto blir fornyet hvert år. Bakgrunnskart er et forenklet situasjonskart som i hovedsak viser bygninger, veier og vann."}));
		
		about.appendChild(aboutArticle);
		
		content.appendChild(about);
		
		//<!--Slett nettleserdata-->
		var storage = creator.createDiv({css: "help-topic"});
		var storageButton = creator.createButton({css: "close-me hide-me", ariaLabel: "vis informasjon om vilkår for bruk av tjenesten", text: "Tilbakestill instillinger"});
		storageButton.onclick = function(){
			$.each(localStorage, function (obj) {
				if (obj.indexOf("planinnsyn") >= 0) {
					localStorage.removeItem(obj);
				}
				$("#hideSketchTip").attr("checked", false);
				$("#hideMeasureTip").attr("checked", false);
			});
			$("#hide-sketch-tip").prop("checked", false);
			$("#hide-measure-tip").prop("checked", false);
			alert("Lokale innstillinger for Planinnsyn har blitt slettet.");
		};
		storage.appendChild(storageButton);
		content.appendChild(storage);
		
		//<!--Gi tilbakemelding-->
		var tilbakemelding = creator.createDiv({css: "Help-topic"});
		var tilbakemeldingBtn = creator.createButton({ariaLabel: "Gi oss tilbakemelding", css: "user-message-intranett", text: "<a>Gi oss tilbakemelding </a>"});
		tilbakemeldingBtn.appendChild(creator.createIcon({css: "glyphicon glyphicon-comment"}));
		tilbakemeldingBtn.onclick = function () {
			var url = "mailto:liva.vagane@pbe.oslo.kommune.no&subject=Tilbakemelding%20Planinnsyn&body=Skriv%20tilbakemeldingen%20din%20her";
			window.location.href = url;
		};
		tilbakemelding.appendChild(tilbakemeldingBtn);

		var tilbakemeldingBtnInternett = creator.createButton({ariaLabel: "Gi oss tilbakemelding", text: "<a>Gi oss tilbakemelding </a>", css: "user-message-internett"});
		tilbakemeldingBtnInternett.appendChild(creator.createIcon({css: "icon-new-window"}));
		tilbakemeldingBtnInternett.onclick = function () {
			window.open("https://innsyn.pbe.oslo.kommune.no/saksinnsyn/getfeedback.asp?side=kartside", "_blank");
			//e.stopPropagation();
		};
		tilbakemelding.appendChild(tilbakemeldingBtnInternett);
		
		content.appendChild(tilbakemelding);
		
		
		el.appendChild(content);
		return el;
	},
	addTopMenuItems: function(topMenuItems, intranett){
		var target = $(".drop-down-link-menu");
		topMenuItems.forEach(function (item) {
			target.prepend(privateFns.addTopMenuItem(item));
		});
		var smallScreenButton = creator.createButton({css: "top-menu-button small-screen", ariaLabel: "Se flere valg"});
		smallScreenButton.style.color = "#2A2859";
		smallScreenButton.appendChild(creator.createIcon({css: "glyphicon glyphicon-option-vertical"}));
		smallScreenButton.onclick = function(){
			var target = $(".drop-down-link-menu");
			$(".drop-downs").hide();
			if ($(window).width() < 767) {
				$("#searchinput").hide();
			}
			target.toggleClass("show-collapsible");
		};
		$("#middleDiv").prepend(smallScreenButton);
	},
	addTopMenuItem: function (item, intranett) {
		var itemElement = creator.createButton({});
		if (item.type === "button") {
			itemElement.type = "button";
			itemElement.id = item.id;
			itemElement.className = "drop-down-row";
			itemElement.title = item.toolTip;
			itemElement.innerHTML = "";
			itemElement.innerHTML += item.innerHTML;
			if (item.icon) {
				itemElement.innerHTML += "<i class='" + item.iconClass + "'></i>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if (item.svg) {
				itemElement.innerHTML += "<img src='" + item.iconClass + "'></img>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if(typeof item.onclick === "function") {
				itemElement.onclick = item.onclick;
			}else {
				itemElement.onclick = clickFns[item.onclick];
			}
			if(item.contentPage){
				$("#map").append(privateFns[item.contentPage]());
			}
		}
		return itemElement;
	},
	createWKTStringFromFeatures: function () {
		var wktString = "";
			for (const [key, plug] of Object.entries(global.registeredPlugins)) {
				var shareString = "", paramName;
				if(plug.share){
					shareString += plug.share();
					paramName = plug.id;
				}
				if (shareString && shareString.length > 0) {
					shareString = "&" + paramName + "=" + encodeURIComponent(shareString);
				}
				wktString += shareString;
			}
		return wktString;
	},
	updateUrl: function () {
		//var urlBase = {partList: {}, addPart: {}};
		let siteUrl = "http://" + location.hostname + location.pathname;
		for (var key in urlBase.addPart){
			if(urlBase.addPart[key]){
				siteUrl += urlBase.partList[key];
			}
		}
		let wktString = privateFns.createWKTStringFromFeatures();
		if(wktString && wktString.length > 0){				
			siteUrl += wktString;
		}
		
		var permalink = creator.createA({css: "permalink"});
		permalink.innerHTML = siteUrl;
		permalink.href = siteUrl;
		
		$(".share-url").html(permalink);
		
	},
	togglePermalinkSharingBtns: function (siteUrl) {
		if (siteUrl.length >= 2000) {
			siteUrl = "Url-en er for lang på grunn av for mange tegninger, målinger eller kommentarer";
			$(".user-message-intranett").hide();
			$("#copy-link").hide();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		} else if (siteUrl.length >= 1840) {
			$("#copy-link").show();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
			if (intranett) {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost. Du kan fortsatt kopiere url-en manuelt og dele den.");
			} else {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost, twitter og facebook. Du kan fortsatt kopiere url-en manuelt og dele den.");
			}
		} else if (siteUrl.length > 140) {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").hide();
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		} else {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").show().attr("href", "http://twitter.com/share?url=" + encodeURIComponent(siteUrl));
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		}

		if (intranett) {
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		}
		return siteUrl;
	},
};

clickFns = {
	shareClick: function(){
		$("#share-page").toggle(250);
		$("#help-page").hide(250);
		var permalink = creator.createA({css: "permalink"});
		var lyrArray = [];
		global.forAllLayers(global.map, function (l) {
			if (l.getVisible() && l.get("group") !== "hidden" && l.get("displayInLayerMenu") && !l.get("layers") && $("#"+l.values_.layerId)[0]) {
				lyrArray.push(l.values_.layerId);
			}
		});
		urlBase.partList.list = global.list ? "?list=" + global.list : "?";
		urlBase.addPart.list = true;
		
		urlBase.partList.mode = "&mode=" + lyrArray.join(",");
		urlBase.addPart.mode = true;
		
		urlBase.partList.point = "&north=" + global.map.getView().getCenter()[1]  + "&east=" + global.map.getView().getCenter()[0];
		urlBase.addPart.point = true;
		
		urlBase.partList.pointMark = "&lat=" + global.map.getView().getCenter()[1]  + "&lon=" + global.map.getView().getCenter()[0];
		urlBase.addPart.pointMark = false;
		
		privateFns.updateUrl();
	},
};

export default {
	initiate: function(items, intranett){
		intranett = intranett; 
		privateFns.addTopMenuItems(items);
		if (intranett) {
			$(".user-message-intranett").show();
		} else {
			$(".user-message-internett").show();
		}
	},
};

